if (!customElements.get('td-slideshow-lite')) {
  class TdSlideshowLite extends HTMLElement {
    static SELECTORS = {
      slider: '[data-td-slideshow-lite-slider]',
      activeProgressRing: "[data-td-slideshow-lite-dot][aria-selected='true'] [data-td-progress-ring]",
    };

    static EVENTS = {
      slideshowSelect: 'slideshow:select',
    };

    constructor() {
      super();
      this.sliderElement = this.querySelector(TdSlideshowLite.SELECTORS.slider);
      this.autoplayEnabled = this.dataset.tdAutoplayEnabled === 'true';
      this.progressNavigationEnabled =
        this.sliderElement instanceof HTMLElement && this.sliderElement.dataset.tdProgressNavigation === 'true';
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onReducedMotionChange = this.onReducedMotionChange.bind(this);
      this.onSlideshowSelect = this.onSlideshowSelect.bind(this);
    }

    connectedCallback() {
      if (this.sliderElement) {
        this.sliderElement.addEventListener(TdSlideshowLite.EVENTS.slideshowSelect, this.onSlideshowSelect);
      }

      if (typeof this.reducedMotionQuery.addEventListener === 'function') {
        this.reducedMotionQuery.addEventListener('change', this.onReducedMotionChange);
      } else {
        this.reducedMotionQuery.addListener(this.onReducedMotionChange);
      }

      this.updateAutoplayState();
    }

    disconnectedCallback() {
      if (this.sliderElement) {
        this.sliderElement.removeEventListener(TdSlideshowLite.EVENTS.slideshowSelect, this.onSlideshowSelect);
      }

      if (typeof this.reducedMotionQuery.removeEventListener === 'function') {
        this.reducedMotionQuery.removeEventListener('change', this.onReducedMotionChange);
      } else {
        this.reducedMotionQuery.removeListener(this.onReducedMotionChange);
      }
    }

    onReducedMotionChange() {
      this.updateAutoplayState();
    }

    onSlideshowSelect(event) {
      if (!this.autoplayEnabled || this.reducedMotionQuery.matches) {
        return;
      }

      const detail = event?.detail || {};
      if (!detail.userInitiated || detail.trigger === 'scroll') {
        return;
      }

      const slideshow = this.getSlideshow();
      if (!slideshow) {
        return;
      }

      if (slideshow.paused === true) {
        slideshow.paused = false;
      }

      if (typeof slideshow.resume === 'function') {
        slideshow.resume();
      }

      this.restartProgressAnimation();
    }

    getSlideshow() {
      if (!(this.sliderElement instanceof HTMLElement)) {
        return null;
      }

      return this.sliderElement;
    }

    restartProgressAnimation() {
      if (!this.progressNavigationEnabled) {
        return;
      }

      const slideshow = this.getSlideshow();
      if (!slideshow) {
        return;
      }

      const progressRing = slideshow.querySelector(TdSlideshowLite.SELECTORS.activeProgressRing);
      if (!(progressRing instanceof Element)) {
        return;
      }

      progressRing.style.animation = 'none';
      progressRing.getBoundingClientRect();
      progressRing.style.removeProperty('animation');
    }

    updateAutoplayState() {
      if (!this.autoplayEnabled) {
        return;
      }

      const slideshow = this.getSlideshow();
      if (!slideshow) {
        return;
      }

      if (this.reducedMotionQuery.matches) {
        if (typeof slideshow.pause === 'function') {
          slideshow.pause();
        }
        return;
      }

      if (slideshow.paused === true) {
        slideshow.paused = false;
      }

      if (typeof slideshow.resume === 'function') {
        slideshow.resume();
      }

      this.restartProgressAnimation();
    }
  }

  customElements.define('td-slideshow-lite', TdSlideshowLite);
}
